import { render, staticRenderFns } from "./MallCenter.vue?vue&type=template&id=7b232b66&scoped=true"
import script from "./MallCenter.vue?vue&type=script&lang=js"
export * from "./MallCenter.vue?vue&type=script&lang=js"
import style0 from "./MallCenter.vue?vue&type=style&index=0&id=7b232b66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b232b66",
  null
  
)

export default component.exports